import { useAppStore } from '@/stores'

export const useDataLayerHelpers = () => {
  const appStore = useAppStore()

  const getLastSlugPart = (url: string) => {
    if (!url) return '/'
    return url.split('/').pop()
  }

  const getPageType = (): string => {
    return appStore.cmsData.slug || 'company_home_page'
  }

  return { getPageType, getLastSlugPart }
}
